import { IconName } from '@purpur/library/icon';

export const TOOLTIP_SUPPORTED_ICONS = ['info-filled', 'info'] as const satisfies IconName[];

export const Z_INDEX_TOOLTIP = 1050;
